
import React from 'react';
import { Route, Routes } from "react-router-dom";
import Change_pass from "./mc/Change_pass";
import Home from "./mc/Home";
import Loginv1 from "./mc/Loginv1";
import Master_city_list from "./mc/master/Master_city_list";
import Master_country_list from "./mc/master/Master_country_list";
import Master_dealer_category from "./mc/master/Master_dealer_category";
import Master_group_right from "./mc/master/Master_group_right";
import Master_id_type from "./mc/master/Master_id_type";
import Master_isd_list from "./mc/master/Master_isd_list";
import Master_issuer_list from "./mc/master/Master_issuer_list";
import Master_purpose_list from "./mc/master/Master_purpose_list";
import Master_region_list from "./mc/master/Master_region_list";
import Master_state_list from "./mc/master/Master_state_list";
import Master_user from "./mc/master/Master_user";
import Master_voucher_group from "./mc/master/financial/Master_voucher_group";
import Master_voucher_ledger from "./mc/master/financial/Master_voucher_ledger";
import Master_voucher_ledger_view from "./mc/master/financial/Master_voucher_ledger_view";


import Fin_year from "./mc/Fin_year";
import Testing from './mc/Testing';
import Bank_cheque_book_cancellation from "./mc/bank/Bank_cheque_book_cancellation";
import Bank_cheque_book_transfer_in from "./mc/bank/Bank_cheque_book_transfer_in";
import Bank_cheque_book_transfer_out from "./mc/bank/Bank_cheque_book_transfer_out";
import Bank_reconciliation from './mc/bank/Bank_reconciliation';
import Cheque_Deposit from "./mc/bank/Cheque_Deposit";
import Issue_Cheque_Bounce from "./mc/bank/Issue_Cheque_Bounce";
import Received_cheque_bounce from "./mc/bank/Received_cheque_bounce";
import Master_IBR from "./mc/master/Master_IBR";
import Master_business_nature from './mc/master/Master_business_nature';
import Master_cost_center from "./mc/master/Master_cost_center";
import Master_country_class from "./mc/master/Master_country_class";
import Master_designation from './mc/master/Master_designation';
import Master_district_list from "./mc/master/Master_district_list";
import Master_dsr from "./mc/master/Master_dsr";
import Master_entity from "./mc/master/Master_entity";
import Master_executive from "./mc/master/Master_executive";
import Master_gst_classification from './mc/master/Master_gst_classification';
import Master_individual_profile from "./mc/master/Master_individual_profile";
import Master_ledger_link from "./mc/master/Master_ledger_link";
import Master_legal_entity from './mc/master/Master_legal_entity';
import Master_margin from "./mc/master/Master_margin";
import Master_msme from "./mc/master/Master_msme";
import Master_residential_status from "./mc/master/Master_residential_status";
import Master_risk from "./mc/master/Master_risk";
import Sample_Form from "./mc/master/Sample_Form";
import Master_agent_linking from "./mc/master/financial/Master_agent_linking";
import Master_group_doc from "./mc/master/financial/Master_group_doc";
import Master_voucher_type from "./mc/master/financial/Master_voucher_type";
import Master_division from "./mc/master/Master_division";
import Rate_card from './mc/reports/Rate_card';
import Repcommission_status from './mc/reports/commission/Repcommission_status';
import Bill_wise_detail_payable from "./mc/reports/financial/Bill_wise_detail_payable";
import Cheque_used_report from "./mc/reports/financial/cheque/Cheque_used_report";
import Cheques_in_hand from "./mc/reports/financial/cheque/Cheques_in_hand";
//import Ledger from "./mc/reports/financial/Ledger";
import Rep_ledger from "./mc/reports/financial/Rep_ledger";

import Master_Source_Of_Fund from './mc/master/Master_Source_Of_Fund';
import Master_bank_all from './mc/master/Master_bank_all';
import Master_Budget from './mc/master/Master_Budget';
import Master_Budget_Executive from './mc/master/Master_Budget_Executive';
import Master_visa_type from './mc/master/Master_visa_type';
import Rep_fin_Bill_wise_detail from "./mc/reports/financial/Rep_fin_bill_wise_detail";
import Trial_balance from "./mc/reports/financial/Trial_balance";
import Cheque_utilization from "./mc/reports/financial/cheque/Cheque_Utilization";

import Rep_outstanding_cmrp from "./mc/reports/financial/outstanding/Rep_outstanding_cmrp";
import Activity_log_report from "./mc/reports/mis/Activity_log_report";
import Manual_book_report from "./mc/reports/mis/Manual_book_report";
import Rep_vtm_settlement from "./mc/reports/mis/Rep_vtm_settlement";
import Tran_payment_report from "./mc/reports/mis/Tran_payment_report";
import Transaction_report from "./mc/reports/mis/Transaction_report";
import Vtm_utlization from "./mc/reports/mis/Vtm_utlization";
import Stock_in_hand_report from "./mc/reports/mis/currency/Stock_in_hand_report";
import Flm1_report from "./mc/reports/rbi/Flm1_report";
import RepCommission from "./mc/reports/tds/RepCommission";
import Accept_interbranch from "./mc/transaction/Accept_interbranch";
import FundRequest from "./mc/transaction/FundRequest";
import Fx_document from "./mc/transaction/Fx_document";
import Modification_commission from './mc/transaction/Modification/Modification_commission.js';
import Modification_date from './mc/transaction/Modification/Modification_date';
import Modification_transaction from './mc/transaction/Modification/Modification_transaction';
import Tran_modification_payment from './mc/transaction/Modification/Tran_modification_payment.js';
import Opn_bank_statement from "./mc/transaction/Opn_bank_statement";
import Tran_cancellation from "./mc/transaction/Tran_cancellation";
import Tran_commission_module from "./mc/transaction/Tran_commission_module";
import Tran_currency_stock from "./mc/transaction/Tran_currency_stock";
import Tran_data_unlock from "./mc/transaction/Tran_data_unlock";
import Tran_evtm_surrender from "./mc/transaction/Tran_evtm_surrender";
import Tran_glvtm_settlement from "./mc/transaction/Tran_glvtm_settlement";
import Tran_manual_book_cancellation from "./mc/transaction/Tran_manual_book_cancellation";
import Tran_opn_cmrcmp from "./mc/transaction/Tran_opn_cmrcmp";
import Tran_opn_etc from "./mc/transaction/Tran_opn_etc";
import Tran_opn_evtm from "./mc/transaction/Tran_opn_evtm";
import Tran_opn_tc from "./mc/transaction/Tran_opn_tc";
import Tran_opn_tc_settlement from "./mc/transaction/Tran_opn_tc_settlement";
import Tran_opn_vtc from "./mc/transaction/Tran_opn_vtc";
import Tran_opn_vtm_settlement from "./mc/transaction/Tran_opn_vtm_settlement";
import Tran_pb from "./mc/transaction/Tran_pb";
import Tran_pi from "./mc/transaction/Tran_pi";
import Tran_pp from "./mc/transaction/Tran_pp";
import Tran_sb from "./mc/transaction/Tran_sb";
import Tran_si from './mc/transaction/Tran_si';
import Tran_sp from "./mc/transaction/Tran_sp";
import Tran_trf_manual_book from "./mc/transaction/Tran_trf_manual_book";
import Tran_trf_out_currency from "./mc/transaction/Tran_trf_out_currency";
import Tran_trf_out_vtc from './mc/transaction/Tran_trf_out_vtc';
import Tran_trf_vtc from "./mc/transaction/Tran_trf_vtc";
import Tran_vtm_activation from "./mc/transaction/Tran_vtm_activation";
import Tran_vtm_encashment from "./mc/transaction/Tran_vtm_encashment";
import Tran_vtm_settlement from "./mc/transaction/Tran_vtm_settlement";
import Additional_limit from './mc/transaction/others/Additional_limit';
import Currency_change from './mc/transaction/others/Currency_change';
import Currency_write_off from "./mc/transaction/others/Currency_write_off";
import Expense_transfer from "./mc/transaction/others/Expense_transfer";
import Internal_fund_transfer from "./mc/transaction/others/Internal_fund_transfer";
import Tran_conveyance_entry from './mc/transaction/others/Tran_conveyance_entry';
import Tran_module_payment from "./mc/transaction/others/Tran_module_payment";
import Tran_opn_trial from "./mc/transaction/Tran_opn_trial";
import Inter_branch_entry from "./mc/transaction/voucher/Inter_branch_entry";
import Tran_cross_knockoff from "./mc/transaction/voucher/Tran_cross_knockoff";
import Tran_cross_knockoff_updated from "./mc/transaction/voucher/Tran_cross_knockoff_updated";

import Tran_fa_book from "./mc/transaction/voucher/Tran_fa_book";
import Tran_knockoff_view from './mc/transaction/voucher/Tran_knockoff_view';
// import Tran_tt_salse from './mc/transaction/Tran_tt_sales.js';

import Balance_sheet from './mc/reports/financial/Balance_sheet.js';
import Stock_valuation from './mc/reports/financial/Rep_stock_valuation.js';
import Rep_stock_valuation_without_comm from './mc/reports/financial/Rep_stock_valuation_without_comm.js';
import Rep_stock_valuation_profitability from './mc/reports/financial/Rep_stock_valuation_profitability.js';
import Rep_valuation from "./mc/reports/financial/Rep_valuation";
import Rep_teller_sheet from './mc/reports/mis/Rep_teller_sheet.js';
import Rep_profitability_transaction from "./mc/reports/mis/profitability/Rep_profitability_transaction";
import Rep_profitability_contribution from "./mc/reports/mis/profitability/Rep_profitability_contribution";
import Rep_vtm_profitability from "./mc/reports/mis/profitability/Rep_vtm_profitability";
import Rep_Profitablitity_Ad2_Analysis from "./mc/reports/mis/profitability/Rep_profitability_ad2_analysis.js";
import Rep_vtm_in_out from './mc/reports/mis/vtm/Rep_vtm_in_out.js';
import VTM_status_report from './mc/reports/mis/vtm/VTM_status_report.js';
import Rep_gst from "./mc/reports/rbi/Rep_gst";
import Rep_rbi_purchase_statement from "./mc/reports/rbi/Rep_rbi_purchase_statement";
import Rep_rbi_turnover from "./mc/reports/rbi/Rep_rbi_turnover";
import Rep_sftp from "./mc/reports/statutory/Rep_sftp.js";
import Rep_ctr from "./mc/reports/statutory/Rep_ctr.js";
import Tran_pp_adii from './mc/transaction/Tran_pp_adii.js';
import Tran_trf_out_issuer_vtm from './mc/transaction/Tran_trf_out_issuer_vtm.js';
import Tran_tt_settlement from './mc/transaction/Tran_tt_settlement.js';
import Master_sanctions_header from './mc/master/Master_sanctions_header';
import A2formSP from './mc/transaction/A2_FormSP.js';
import Cheque_received from './mc/reports/financial/cheque/Cheque_received.js';
import Tran_vtm_in_view from "./mc/transaction/Tran_vtm_in_view";
import Tran_currency_in_view from "./mc/transaction/Tran_currency_in_view";
import Tran_cheque_in_view from "./mc/transaction/Tran_cheque_in_view";
import Rep_knockoff from "./mc/reports/financial/Rep_knockoff.js";
import Rep_cheque_status from './mc/reports/financial/cheque/Rep_cheque_status.js';
import Rep_tcs from "./mc/reports/rbi/Rep_tcs";
import Master_risk_configuration from './mc/master/Master_risk_configuration.js';
import TCS_eligibility_report from './mc/reports/financial/TCS_eligibility_report.js';
import Tran_sanctions_approval from './mc/transaction/others/Tran_sanctions_approval.js';
import Rep_lrs from "./mc/reports/mis/Rep_lrs";
import Rep_insurance from "./mc/reports/mis/Rep_insurance";
import Rep_position_summary from "./mc/reports/mis/Rep_position_summary";
import Tran_adii_inward from "./mc/transaction/tran_adii_inward.js";
import Rep_outstanding_cmrp_ageing from "./mc/reports/financial/outstanding/Rep_outstanding_cmrp_ageing";
import Rep_mtm from "./mc/reports/Rep_mtm";
import Rep_transaction_mis from "./mc/reports/Rep_transaction_mis";
import Remittence_tour_reports from './mc/reports/mis/Remittence/Remittence_tour_reports.js';
import Purchase_sale_report from './mc/reports/mis/Purchase_sale_report.js';
import TranScanningReport from './mc/reports/mis/Tran_scanning_report.js';
import TranModificationDsrDer from './mc/transaction/Modification/Tran_modification_dsr_der.js';
import A2form from './mc/transaction/A2_Form.js';
import Tran_principle_module from './mc/transaction/Tran_principle_module.js';
import Fund_transfer from './mc/transaction/Fund_transfer.js';

import Master_Airline from './mc/master/Master_Airline';
import Tran_pan_whitelisting from "./mc/transaction/Tran_pan_whitelisting.js";
import Rep_commission from "./mc/reports/mis/Rep_commission";
import Rep_dashboard from "./mc/reports/mis/Rep_dashboard";
import ModificationTranctionCardExecutivePurpose from './mc/transaction/Modification/ModificationTransactionCardExcecutivePurpose.js';
import SpPpModification from './mc/transaction/Modification/SpPpModification.js';
import Tran_fa_view from './mc/transaction/voucher/Tran_fa_view.js';
import TutionFeePage from './mc/convera/TutionFeeForm.js';
import Rep_principle_report from './mc/reports/Rep_principle_report.js';
import Rep_mis from './mc/reports/Rep_mis.js';
import ConveraPayment from './mc/convera/Convera.js';
import VerifyMobileEmailOtp from './mc/verifyMobileEmailOtp.js';
import Tran_usd_configuration from "./mc/transaction/Tran_usd_configuration.js";
import Master_sub_executive from './mc/master/Master_sub_executive.js';
import FundTransferInternal from './mc/transaction/Fund_transfer_internal.js';
import Expense_tran from './mc/transaction/Expense_trans.js';
import Tran_adi from './mc/transaction/Tran_adi.js';
import Master_local_expense from './mc/master/Master_local_expense.js';
import Master_Credit_Schedule from './mc/master/Master_credit_schedule.js';
import Master_aws_data from "./mc/master/Master_aws_data";
import Opening_Inward_Utilization from "./mc/reports/mis/tt/Opening_inward_utilization.js";
import Rep_ett_liability from "./mc/reports/mis/tt/Ett_Liability.js";


let footerDiv = {
    position: 'fixed',
    bottom: '0',
    width: '100%',
    backgroundColor: '#00A1E4',
    color: '#ffffff'
}

function App() {
    return (
        <div>
            <Routes>
                <Route exact path="/" element={<Loginv1 />}></Route>
                <Route exact path="*" element={<Loginv1 />}></Route>
                <Route exact path="/login" element={<Loginv1 />}></Route>
                <Route exact path="/home" element={<Home />}></Route>
                <Route exact path="/user-list" element={<Master_user />}></Route>
                <Route exact path="/right-list" element={<Master_group_right />}></Route>
                <Route exact path="/changepassword" element={<Change_pass />}></Route>
                <Route exact path="/country-list" element={<Master_country_list />}></Route>
                <Route exact path="/city-list" element={<Master_city_list />}></Route>
                <Route exact path="/state-list" element={<Master_state_list />}></Route>
                <Route exact path="/issuer-list" element={<Master_issuer_list />}></Route>
                <Route exact path="/purpose-list" element={<Master_purpose_list />}></Route>
                <Route exact path="/isd-list" element={<Master_isd_list />}></Route>
                <Route exact path="/id-type" element={<Master_id_type />}></Route>
                <Route exact path="/dealer-list" element={<Master_dealer_category />}></Route>
                <Route exact path="/voucher-group" element={<Master_voucher_group />}></Route>
                <Route exact path="/voucher-ledger" element={<Master_voucher_ledger />}></Route>
                <Route exact path="/voucher-ledger-view" element={<Master_voucher_ledger_view />}></Route>

                <Route exact path="/region-list" element={<Master_region_list />}></Route>
                <Route exact path="/country-class" element={<Master_country_class />}></Route>
                <Route exact path="/division-list" element={<Master_division />}></Route>
                <Route exact path="/risk-list" element={<Master_risk />}></Route>
                <Route exact path="/business-nature" element={<Master_business_nature />}></Route>
                <Route exact path="/legal-entity" element={<Master_legal_entity />}></Route>
                <Route exact path="/district-list" element={<Master_district_list />}></Route>
                <Route exact path="/cost-center" element={<Master_cost_center />}></Route>
                <Route exact path="/gst-classification" element={<Master_gst_classification />}></Route>
                <Route exact path="/msme" element={<Master_msme />}></Route>
                <Route exact path="/designation" element={<Master_designation />}></Route>
                <Route exact path="/executive" element={<Master_executive />}></Route>
                <Route exact path="/sub-executive" element={<Master_sub_executive />}></Route>

                <Route exact path="/voucher-type" element={<Master_voucher_type />}></Route>
                {
                    /*
                      <Route path="/purchase-from-public" element={<Tran_purchase_public />}></Route>
                    */
                }

                <Route path="/purchase-from-public" element={<Tran_pp />}></Route>
                <Route exact path="/individual-profile" element={<Master_individual_profile />}></Route>
                <Route exact path="/group-doc" element={<Master_group_doc />}></Route>
                <Route exact path="/financial-year" element={<Fin_year />}></Route>
                <Route exact path="/sampleform" element={<Sample_Form />}></Route>
                <Route exact path="/tran-opn-trial" element={<Tran_opn_trial />}></Route>
                <Route exact path="/residential-status" element={<Master_residential_status />}></Route>
                <Route exact path="/tran-opn-cmrcmp" element={<Tran_opn_cmrcmp />}></Route>
                <Route exact path="/tran-currency-stock" element={<Tran_currency_stock />}></Route>
                <Route exact path="/tran-opn-vtc" element={<Tran_opn_vtc />}></Route>
                <Route exact path="/opn-bank-statement" element={<Opn_bank_statement />}></Route>
                <Route exact path="/tran-opn-tc" element={<Tran_opn_tc />}></Route>
                <Route exact path="/tran-opn-etc" element={<Tran_opn_etc />}></Route>
                <Route exact path="/vtm-encashment" element={<Tran_vtm_encashment />}></Route>
                <Route exact path="/tran-opn-evtm" element={<Tran_opn_evtm />}></Route>
                <Route exact path="/vtm-encashment" element={<Tran_vtm_encashment />}></Route>
                <Route exact path="/vtm-settlement" element={<Tran_opn_vtm_settlement />}></Route>
                <Route exact path="/source-of-fund" element={<Master_Source_Of_Fund />}></Route>
                <Route exact path="/master_bank_all" element={<Master_bank_all />}></Route>
                <Route exact path="/master-budget" element={<Master_Budget />}></Route>
                <Route exact path="/master-budget-executive" element={<Master_Budget_Executive />}></Route>

                <Route exact path="/master_visa_type" element={<Master_visa_type />}></Route>
                {
                    /*
                      <Route exact path="/cheque-book-in" element={<Bank_cheque_book_in />}></Route>
                    */
                }

                <Route exact path="/cheque-book-in" element={<Bank_cheque_book_transfer_in />}></Route>
                <Route exact path="/tc-settlement" element={<Tran_opn_tc_settlement />}></Route>
                {
                    /*
                      <Route exact path="/fa-book-entry" element={<Tran_book_entry />}></Route>
                    */
                }

                <Route exact path="/fa-book-entry" element={<Tran_fa_book />}></Route>
                <Route exact path="/purchase-bulk" element={<Tran_pb />}></Route>
                <Route exact path="/sale-public" element={<Tran_sp />}></Route>
                <Route exact path="/transfer-vtc" element={<Tran_trf_vtc />}></Route>
                <Route exact path="/cheque-deposit" element={<Cheque_Deposit />}></Route>
                <Route exact path="/cheque-book-out" element={<Bank_cheque_book_transfer_out />}></Route>
                <Route exact path="/received-cheque-bounce" element={<Received_cheque_bounce />}></Route>
                <Route exact path="/issue-cheque-bounce" element={<Issue_Cheque_Bounce />}></Route>
                <Route exact path="/bank-reconciliation" element={<Bank_reconciliation />}></Route>
                <Route exact path="/manual-book" element={<Tran_trf_manual_book />}></Route>
                <Route exact path="/ledger" element={<Rep_ledger />}></Route>
                <Route exact path="/testing" element={<Testing />}></Route>
                <Route exact path="/sale-bulk" element={<Tran_sb />}></Route>
                <Route exact path="/trial-balance" element={<Trial_balance />}></Route>
                <Route exact path="/out-vtc" element={<Tran_trf_out_vtc />}></Route>
                <Route exact path="/out-currency" element={<Tran_trf_out_currency />}></Route>
                <Route exact path="/accept-interbranch" element={<Accept_interbranch />}></Route>
                <Route exact path="/rep-fin-recv-bill-wise-detail" element={<Rep_fin_Bill_wise_detail />}></Route>
                <Route exact path="/ledger-link" element={<Master_ledger_link />}></Route>
                <Route exact path="/cheque-in-hand-report" element={<Cheques_in_hand />}></Route>
                <Route exact path="/cheque-used-report" element={<Cheque_used_report />}></Route>
                <Route exact path="/ib-entry" element={<Inter_branch_entry />}></Route>
                <Route exact path="/margin" element={<Master_margin />}></Route>
                <Route exact path="/ibr" element={<Master_IBR />}></Route>
                <Route exact path="/data-unlock" element={<Tran_data_unlock />}></Route>
                <Route exact path="/opening-inward-utilization" element={<Opening_Inward_Utilization />}></Route>
                <Route exact path="/ett-liability" element={<Rep_ett_liability />}></Route>
                <Route exact path="/transaction-report" element={<Transaction_report />}></Route>
                <Route exact path="/currency-writeoff" element={<Currency_write_off />}></Route>
                <Route exact path="/purchase-invoice" element={<Tran_pi />}></Route>
                <Route exact path="/global-vtm-settlement" element={<Tran_glvtm_settlement />}></Route>
                <Route exact path="/currency-change" element={<Currency_change />}></Route>
                <Route exact path="/cancellation" element={<Tran_cancellation />}></Route>
                <Route exact path="/manual-cancellation" element={<Tran_manual_book_cancellation />}></Route>
                <Route exact path="/cheque-cancellation" element={<Bank_cheque_book_cancellation />}></Route>
                <Route exact path="/entity" element={<Master_entity />}></Route>
                <Route exact path="/settlement-vtm" element={<Tran_vtm_settlement />}></Route>
                <Route exact path="/expense-transfer" element={<Expense_transfer />}></Route>
                <Route exact path="/internal-fund-transfer" element={<Internal_fund_transfer />}></Route>
                <Route exact path="/stock-in-hand-report" element={<Stock_in_hand_report />}></Route>
                <Route exact path="/manual-book-report" element={<Manual_book_report />}></Route>
                <Route exact path="/commission-report" element={<Rep_commission />}></Route>
                <Route exact path="/fund-confirmation" element={<FundRequest />}></Route>
                <Route exact path="/master-dsr" element={<Master_dsr />}></Route>
                <Route exact path="/flm-report" element={<Flm1_report />}></Route>
                <Route exact path="/fx-document" element={<Fx_document />}></Route>
                <Route exact path="/evtm-surrender" element={<Tran_evtm_surrender />}></Route>
                <Route exact path="/commission-module" element={<Tran_commission_module />}></Route>
                <Route exact path="/tran-module-payment" element={<Tran_module_payment />}></Route>
                <Route exact path="/agent-linking" element={<Master_agent_linking />}></Route>
                <Route exact path="/bill-wise-detail-payable" element={<Bill_wise_detail_payable />}></Route>
                <Route exact path="/commission-tds" element={<RepCommission />}></Route>
                <Route exact path="/tran-payment-report" element={<Tran_payment_report />}></Route>
                <Route exact path="/conveyance-module" element={<Tran_conveyance_entry />}></Route>
                <Route exact path="/activity-log-report" element={<Activity_log_report />}></Route>
                <Route exact path="/additional-limit" element={<Additional_limit />}></Route>
                <Route exact path="/rate-card" element={<Rate_card />}></Route>
                <Route exact path="/commission-status" element={<Repcommission_status />}></Route>
                <Route exact path="/transaction-modification" element={<Modification_transaction />}></Route>
                <Route exact path="/modification-commission" element={<Modification_commission />}></Route>
                <Route exact path="/modification-date" element={<Modification_date />}></Route>
                <Route exact path="/sale-invoice" element={<Tran_si />}></Route>
                <Route exact path="/payment-modification" element={<Tran_modification_payment />}></Route>
                <Route exact path="/vtm-settlement-report-global" element={<Rep_vtm_settlement />}></Route>
                <Route exact path="/vtm-settlement-report-local" element={<Rep_vtm_settlement />}></Route>
                <Route exact path="/vtm-utilization" element={<Vtm_utlization />}></Route>
                <Route exact path='/cheque_utilization' element={<Cheque_utilization />}></Route>
                <Route exact path="/outstanding-cmrp" element={<Rep_outstanding_cmrp />}></Route>
                <Route exact path="/vtm-activation" element={<Tran_vtm_activation />}></Route>
                <Route exact path="/tran-cross-knockoff" element={<Tran_cross_knockoff />}></Route>
                <Route exact path="/tran-cross-knockoff-updated" element={<Tran_cross_knockoff_updated />}></Route>
                <Route exact path='/tran_knockoff_view' element={<Tran_knockoff_view />}></Route>
                <Route exact path='/rep-vtm-profitability-local' element={<Rep_vtm_profitability />}></Route>
                <Route exact path='/rep-vtm-profitability-global' element={<Rep_vtm_profitability />}></Route>
                <Route exact path='/rep-valuation-local' element={<Rep_valuation />}></Route>
                <Route exact path='/rep-valuation-global' element={<Rep_valuation />}></Route>
                <Route exact path='/sales_ad_ii' element={<Tran_tt_settlement />}></Route>
                <Route exact path='/rep_vtm_profitability' element={<Rep_vtm_profitability />}></Route>
                <Route exact path='/ad2-analysis' element={<Rep_Profitablitity_Ad2_Analysis />}></Route>
                <Route exact path='/rep_valuation' element={<Rep_valuation />}></Route>
                <Route exact path='/rep-rbi-purchase-statement' element={<Rep_rbi_purchase_statement />}></Route>
                <Route exact path='/rep-rbi-turnover' element={<Rep_rbi_turnover />}></Route>
                <Route exact path='/rep-gst' element={<Rep_gst />}></Route>
                <Route exact path='/balance-sheet' element={<Balance_sheet />}></Route>
                <Route exact path='/out-issuer-vtc' element={<Tran_trf_out_issuer_vtm />}></Route>
                <Route exact path='/rep-sftp' element={<Rep_sftp />}></Route>
                <Route exact path='/rep-profitability-transaction' element={<Rep_profitability_transaction />}></Route>
                <Route exact path='/rep-profitability-contribution' element={<Rep_profitability_contribution />}></Route>
                <Route exact path="/master-sanction-header" element={<Master_sanctions_header />}></Route>
                <Route exact path='/vtm-status-report' element={<VTM_status_report />}></Route>
                <Route exact path='/purchase-adii' element={<Tran_pp_adii />}></Route>

                <Route exact path='/rep-stock-valuation' element={<Stock_valuation hideLoginHeader={false} />}></Route>
                <Route exact path='/a2-formSP/:id/:location/:a2Type' element={<A2formSP />}></Route>
                <Route exact path='/rep-vtm-in-out' element={<Rep_vtm_in_out />}></Route>
                <Route exact path='/rep-teller-sheet' element={<Rep_teller_sheet />}></Route>
                <Route exact path='/cheque-received' element={<Cheque_received />}></Route>
                <Route exact path='/vtm-in-view' element={<Tran_vtm_in_view />}></Route>
                <Route exact path='/currency-in-view' element={<Tran_currency_in_view />}></Route>
                <Route exact path='/cheque-in-view' element={<Tran_cheque_in_view />}></Route>
                <Route exact path='/knockoff-report' element={<Rep_knockoff />}></Route>
                <Route exact path='/cheque-status' element={<Rep_cheque_status />}></Route>
                <Route exact path='/rep-tcs' element={<Rep_tcs />}></Route>
                <Route exact path='/risk-configuration' element={<Master_risk_configuration />}></Route>
                <Route exact path='/tcs-eligibility' element={<TCS_eligibility_report />}></Route>
                <Route exact path='/sanctions-approval' element={<Tran_sanctions_approval />}></Route>
                <Route exact path='/rep-ctr' element={<Rep_ctr />}></Route>
                <Route exact path='/rep-lrs' element={<Rep_lrs />}></Route>
                <Route exact path='/rep_insurance' element={<Rep_insurance />}></Route>
                <Route exact path='/rep_position_summary' element={<Rep_position_summary />}></Route>
                <Route exact path='/tran-adii-inward' element={<Tran_adii_inward />}></Route>
                <Route exact path="/rep-outstanding-cmrp-ageing" element={<Rep_outstanding_cmrp_ageing />}></Route>
                <Route exact path="/rep_mtm" element={<Rep_mtm />}></Route>
                <Route exact path="/rep_transaction-mis" element={<Rep_transaction_mis />}></Route>
                <Route exact path='/rep-remittence-tour' element={<Remittence_tour_reports />}></Route>
                <Route exact path='/rep-purchase-sale' element={<Purchase_sale_report />}></Route>
                <Route exact path='/rep-dashboard' element={<Rep_dashboard />}></Route>
                <Route exact path="/tran-scanning-report" element={<TranScanningReport />}></Route>
                <Route exact path="/tran-modification-dsr/der" element={<TranModificationDsrDer />}></Route>

                <Route exact path='/a2-form/:id/:location/:a2Type' element={<A2form />}></Route>
                <Route exact path='/principle-module' element={<Tran_principle_module />}></Route>
                <Route exact path='/fundtransfer' element={<Fund_transfer />}></Route>
                <Route exact path="/airline" element={<Master_Airline />}></Route>
                <Route exact path="/pan-whitelisting" element={<Tran_pan_whitelisting />}></Route>

                <Route exact path="/commission-report" element={<Rep_commission />}></Route>
                <Route exact path="/modification-card-executive-purpose" element={<ModificationTranctionCardExecutivePurpose />}></Route>
                <Route exact path="/sp-pp-modification" element={<SpPpModification />}></Route>
                <Route exact path="/rep-stock-valuation-without-comm" element={<Rep_stock_valuation_without_comm />}></Route>
                <Route exact path="/rep-stock-valuation-profitability" element={<Rep_stock_valuation_profitability />}></Route>
                <Route exact path='/fa-view' element={<Tran_fa_view />}></Route>
                <Route exact path='/rep-prinnciple' element={<Rep_principle_report />}></Route>
                <Route exact path='/rep_mis' element={<Rep_mis />}></Route>
                <Route exact path="/pay-tution-fee" element={<TutionFeePage />}></Route>
                <Route exact path="/convera" element={<ConveraPayment />}></Route>
                <Route exact path="/usd-configuration" element={<Tran_usd_configuration />}></Route>
                <Route exact path="/fund-transfer-internal" element={<FundTransferInternal />}></Route>
                <Route exact path="/expenseTran" element={<Expense_tran />}></Route>
                <Route exact path="/tran-adi" element={<Tran_adi />}></Route>
                <Route exact path="/master-expense" element={<Master_local_expense />}></Route>
                <Route exact path="/credit-schedule" element={<Master_Credit_Schedule />}></Route>
                <Route exact path="/aws-data-list" element={<Master_aws_data />}></Route>        



            </Routes>

            <div style={footerDiv}>
                {
                    /*
                        sessionStorage.getItem("userSrno") == 1 ? <>
                            <div style={{ fontSize: '12px' }}>
                                {sessionStorage.getItem("startDate")}&nbsp;{sessionStorage.getItem("endDate")}&nbsp;{sessionStorage.getItem("dbname")}&nbsp;{sessionStorage.getItem("branchallowed")}
                            </div>

                        </> : null
                    */
                }
                <div style={{ fontSize: '12px', textAlign: 'center' }}>Copyright &copy; 2025 Zenith. All rights reserved.</div>
            </div>


        </div>

    );
}

export default App;
